export default {
  data () {
    return {
      $_sidebarElm: null
    }
  },
  activated () {
    if (this.chart) this.$_resize()
    window.addEventListener('resize', this.$_resize)

    this.$_sidebarElm = document.getElementsByClassName('sidebar-container')[0]
    this.$_sidebarElm && this.$_sidebarElm.addEventListener('transitionend', this.$_sidebarResizeHandler)
  },
  created () {
    if (this.chart) this.$_resize()
    window.addEventListener('resize', this.$_resize)


    this.$_sidebarElm = document.getElementsByClassName('sidebar-container')[0]
    this.$_sidebarElm && this.$_sidebarElm.addEventListener('transitionend', this.$_sidebarResizeHandler)
  },
  deactivated () {
    window.removeEventListener('resize', this.$_resize)

    this.$_sidebarElm && this.$_sidebarElm.removeEventListener('transitionend', this.$_sidebarResizeHandler)
  },
  methods: {
    $_resize () {
      setTimeout(() => {
        if (this.chart) {
          // if(this.$_pageHandlerResize){ // 页面单独的的兼容处理
          //   this.$_pageHandlerResize(document.documentElement.clientWidth) //不包括页面滚动条的宽度
          // }
          this.chart.resize()
        }
      }, 100)
    },
    $_sidebarResizeHandler (e) {
      if (e.propertyName === 'width') {
        this.$_resize()
      }
    }
  }
}
